import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Footer from './Footer.tsx';

interface AppLayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children, showFooter = true }) => {
  return (
    <Flex direction="column" minH="100vh">
      <Box flex="1">
        {children}
      </Box>
      {showFooter && <Footer />}
    </Flex>
  );
};

export default AppLayout;
